import { useCallback } from 'react';

import { PROMPT_ACTION } from 'src/data/prompt';

export const useHandlers = ({ setAnchorEl, setSearchTerm, setFilter, onResultClick, onAction }) => {
  const handleMenuClick = useCallback(
    (event) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleUpdateSearchTerm = useCallback(
    (event) => {
      setSearchTerm(event.target.value);
    },
    [setSearchTerm]
  );

  const handleUpdateFilter = useCallback(
    (filter) => {
      handleMenuClose();
      setFilter(filter);
    },
    [setFilter, handleMenuClose]
  );

  const handleResultClick = useCallback(
    async ({ name, items }) => {
      const selectedItems = await onResultClick({ name, items });
      if (selectedItems?.length) {
        onAction(PROMPT_ACTION.insertExternalChannelItems, { items: selectedItems });
      }
    },
    [onResultClick, onAction]
  );

  return {
    handleMenuClick,
    handleUpdateSearchTerm,
    handleUpdateFilter,
    handleResultClick,
    handleMenuClose,
  };
};
